import * as MerchantCertificateGenerationApi from '@/api/merchant-certificate-generation'

/**
 * 电子奖状 - 证书生成记录
 */

const state = {}

const mutations = {}

const actions = {
  async query ({ commit }, params) {
    return MerchantCertificateGenerationApi.query(params)
  },
  async create ({ commit }, data) {
    return MerchantCertificateGenerationApi.create(data)
  },
  async findById ({ commit }, id) {
    return MerchantCertificateGenerationApi.findById(id)
  },
  async updateEntryValueIds ({ commit }, data) {
    const payload = Object.assign({}, data)
    const id = payload.id
    delete payload.id
    return MerchantCertificateGenerationApi.updateEntryValueIds(id, payload)
  },
  async updateEntries ({ commit }, data) {
    const payload = Object.assign({}, data)
    const id = payload.id
    delete payload.id
    return MerchantCertificateGenerationApi.updateEntries(id, payload)
  },
  async deleteById ({ commit }, id) {
    return MerchantCertificateGenerationApi.deleteById(id)
  },
  async generate ({ commit }, id) {
    return MerchantCertificateGenerationApi.generate(id)
  },
  async publish ({ commit }, id) {
    return MerchantCertificateGenerationApi.publish(id)
  },
  async unpublish ({ commit }, id) {
    return MerchantCertificateGenerationApi.unpublish(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-certificate-generation.js